// Angular imports
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

// Third-party libraries
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// Project libraries
import { ComponentsModule } from '@tgx/shared/ui/components';
import { SharedUiStorybookModule } from '@tgx/shared/ui/storybook';
import { UserManagementModule } from '@tgx/shared/user-management/module';

// Local components
import { OnboardingImplementationComponent } from './onboarding-implementation.component';
import { OnboardingImplementationRoutingModule } from './onboarding-implementation-routing.module';
import { OnboardingImplementationHomeComponent } from './components/onboarding-implementation-home/onboarding-implementation-home.component';
import { OnboardingImplementationSellerPullComponent } from './components/onboarding-implementation-seller-pull/onboarding-implementation-seller-pull.component';
import { OnboardingImplementationSellerPushComponent } from './components/onboarding-implementation-seller-push/onboarding-implementation-seller-push.component';
import { OnboardingImplementationHeaderComponent } from './components/onboarding-implementation-header/onboarding-implementation-header.component';
import { OnboardingImplementationProgressbarStepsComponent } from './components/onboarding-implementation-progressbar-steps/onboarding-implementation-progressbar-steps.component';
import { OnboardingImplementationService } from './services/onboarding-implementation.service';
import { OnboardingValidationModalComponent } from './components/onboarding-validation-modal/onboarding-validation-modal.component';
import { OnboardingAinaChatComponent } from './components/onboarding-aina-chat/onboarding-aina-chat.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    OnboardingImplementationRoutingModule,
    SharedUiStorybookModule,
    NgbModule,
    ComponentsModule,
    UserManagementModule,
  ],
  declarations: [
    OnboardingImplementationComponent,
    OnboardingImplementationHomeComponent,
    OnboardingImplementationSellerPullComponent,
    OnboardingImplementationSellerPushComponent,
    OnboardingImplementationHeaderComponent,
    OnboardingImplementationProgressbarStepsComponent,
    OnboardingValidationModalComponent,
    OnboardingAinaChatComponent,
  ],
  providers: [OnboardingImplementationService],
})
export class OnboardingImplementationModule {}
